<template>
  <div id="accordion"
    v-if="contractDetails.statusId !== contractStatusEnum.Valid && contractDetails.statusId !== contractStatusEnum.Expired">
    <div class="card najiz-card-panel mb-3">
      <div class="card-header najiz-panel-header" id="headingOne">
        <h4 class="mb-0 py-3">
          <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
          <b>
            مدة العقد
          </b>
        </h4>
      </div>
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body" v-if="contractDetails">
          <div class="d-flex" v-if="contractDetails && contractDetails.startDate && contractDetails.endDate">
            <div>
              <label for="disabledTextInput">تاريخ بداية العقد</label>
              <p class="mb-0"> <b> {{ contractDetails.startDate.gregDate | formatGregToHijri }} هـ </b>
              </p>
            </div>
            <div class="mx-15">
              <label for="disabledTextInput">تاريخ نهاية العقد</label>
              <p class="mb-0"> <b> {{ contractDetails.endDate.gregDate | formatGregToHijri }} هـ </b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { ContractDetails } from '@/models/contractDetailsModel';
import { ContractStatusEnum } from '@/enums/contract-status.enum';

@Component
export default class ContractDurationComponent extends Vue {
  @Prop({ required: true }) contractDetails!: ContractDetails;

  contractStatusEnum = ContractStatusEnum;
}
</script>
@/enums/contract-status.enum